var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "create__scope" }, [
    _c(
      "div",
      { staticClass: "nr_container_content" },
      [
        _c("h1", { staticClass: "mb-5 mt-30" }, [
          _vm._v("Добавление вида упаковки"),
        ]),
        _vm._v(" "),
        _c(
          "v-form",
          {
            staticClass: "form",
            model: {
              value: _vm.valid,
              callback: function ($$v) {
                _vm.valid = $$v
              },
              expression: "valid",
            },
          },
          [
            _c("div", { staticClass: "inner" }, [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column mb-3" },
                  [
                    _c("v-checkbox", {
                      attrs: { label: "Активность", "hide-details": "" },
                      on: {
                        change: function ($event) {
                          return _vm.change_activity()
                        },
                      },
                      model: {
                        value: _vm.activity,
                        callback: function ($$v) {
                          _vm.activity = $$v
                        },
                        expression: "activity",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Таб "),
                    _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "input",
                    attrs: {
                      outlined: "",
                      rules: [_vm.rules.required],
                      placeholder: "прим.Бытовые холодильники",
                    },
                    model: {
                      value: _vm.title,
                      callback: function ($$v) {
                        _vm.title = $$v
                      },
                      expression: "title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                _vm._l(_vm.points, function (point, idx) {
                  return _c("div", { key: idx }, [
                    point.visibleModal
                      ? _c("div", { staticClass: " box_area" }, [
                          _c("div", { staticClass: "box_area__modal" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Название точки "),
                                ]),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "input nameOfCategory",
                                  attrs: { outlined: "" },
                                  model: {
                                    value: point.nameOfCategory,
                                    callback: function ($$v) {
                                      _vm.$set(point, "nameOfCategory", $$v)
                                    },
                                    expression: "point.nameOfCategory",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Текст"),
                                ]),
                                _vm._v(" "),
                                _c("vue-editor", {
                                  staticClass: "w-100",
                                  model: {
                                    value: point.editorContent,
                                    callback: function ($$v) {
                                      _vm.$set(point, "editorContent", $$v)
                                    },
                                    expression: "point.editorContent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(
                                  "Координаты точки(для справки - не редактируются)"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("Top: "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: point.pointPositionTop,
                                      expression: "point.pointPositionTop",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    placeholder: "top",
                                    disabled: "",
                                  },
                                  domProps: { value: point.pointPositionTop },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        point,
                                        "pointPositionTop",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("Left: "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: point.pointPositionLeft,
                                      expression: "point.pointPositionLeft",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    placeholder: "left",
                                    disabled: "",
                                  },
                                  domProps: { value: point.pointPositionLeft },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        point,
                                        "pointPositionLeft",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "send_custom mt-4",
                                  on: {
                                    click: function ($event) {
                                      point.draggable = false
                                      _vm.activePointInd = ""
                                      point.visibleModal = false
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Применить к точке\n                    "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Картинка")]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-wrap" }, [
                  _c("div", { staticClass: "banner mr-4 mb-5" }, [
                    _vm.banner_preview.src
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "drag_area w-100 h-100 position-absolute",
                            class: [
                              typeof _vm.activePointInd == "number"
                                ? "cursor-none pointFix"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                typeof _vm.activePointInd == "number"
                                  ? _vm.pointFix()
                                  : ""
                              },
                              mousemove: function ($event) {
                                return _vm.moveCursorArea($event)
                              },
                            },
                          },
                          _vm._l(_vm.points, function (point, idx) {
                            return _c("div", {
                              key: idx,
                              staticClass: "drag_area__item",
                              class: [point.draggable ? "active" : ""],
                              style: {
                                top: Math.abs(point.pointPositionTop) + "%",
                                left: Math.abs(point.pointPositionLeft) + "%",
                              },
                              attrs: {
                                title:
                                  "Двойной клик - режим правки текста. Одинарный - перемещение точки",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pointMoving(point, idx)
                                },
                                dblclick: function ($event) {
                                  return _vm.pointEditContent(idx)
                                },
                              },
                            })
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      ref: "banner",
                      staticClass: "file_input",
                      attrs: { type: "file", accept: "image/*" },
                      on: {
                        change: function ($event) {
                          return _vm.select_file("banner")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.banner_preview.src
                      ? _c("img", {
                          staticClass: "preview",
                          attrs: {
                            src: _vm.banner_preview.src,
                            alt: _vm.banner_preview.name,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        staticClass: "icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "40",
                          height: "40",
                          viewBox: "0 0 40 40",
                          fill: "none",
                        },
                      },
                      [
                        _c(
                          "g",
                          { attrs: { "clip-path": "url(#clip0_728_42948)" } },
                          [
                            _c("path", {
                              attrs: {
                                d: "M31.6667 15H25V5H15V15H8.33337L20 26.6667L31.6667 15ZM8.33337 30V33.3333H31.6667V30H8.33337Z",
                                fill: "#8B8B8B",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("defs", [
                          _c("clipPath", { attrs: { id: "clip0_728_42948" } }, [
                            _c("rect", {
                              attrs: {
                                width: "40",
                                height: "40",
                                fill: "white",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn_menu " }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn_def add_point p-4 mb-4",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addPoint.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                  Добавить точку\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn_def remove_point p-4 mb-4",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.remove_point.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                  Удалить активную точку\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn_def replace_img p-4",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.replace_img.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v("\n                  Заменить картинку "),
                        _c("br"),
                        _vm._v("(точки не сбросятся)\n                "),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons mb-5" }, [
              _c(
                "button",
                {
                  ref: "send_btn",
                  staticClass: "send_custom",
                  attrs: { disabled: !_vm.valid },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.send_data.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n            Сохранить\n          ")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.modal
          ? _c("div", { staticClass: "create__scope__modal" }, [
              _c("div", { ref: "modal", staticClass: "modal__inner" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "50",
                      height: "50",
                      viewBox: "0 0 50 50",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M45.8333 23.0848V25.0015C45.8307 29.4941 44.376 33.8654 41.6861 37.4636C38.9961 41.0619 35.2151 43.6942 30.907 44.968C26.5988 46.2418 21.9942 46.0888 17.7801 44.5319C13.566 42.975 9.96799 40.0975 7.52279 36.3287C5.0776 32.5599 3.91619 28.1016 4.21179 23.6188C4.50738 19.136 6.24414 14.8689 9.16304 11.4537C12.0819 8.03863 16.0266 5.65855 20.4087 4.66848C24.7908 3.6784 29.3755 4.13138 33.4791 5.95984",
                        stroke: "#FA4237",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M45.8333 8.33594L25 29.1901L18.75 22.9401",
                        stroke: "#FA4237",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "modal__title" }, [
                  _vm._v("\n            Отправлено\n          "),
                ]),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }